/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
import React from 'react'
import styled from 'styled-components'
import { AnimatePresence, motion } from 'framer-motion'
import parse from 'html-react-parser'

import plusIcon from '../img/icons/+.svg'
import closeIcon from '../img/icons/x.svg'
import chevronDownIcon from '../img/icons/chevron-down.svg'

const Taxonomy = styled.div`
  ${(props) =>
    props.main ? `border: 1px solid ${props.theme.color.contrast}` : ''};
  cursor: pointer;
  margin-bottom: 2px;

  input {
    display: none;
  }

  input:hover ~ label .collapser {
    //border: 2px solid #2b2652;
  }

  input:checked ~ label {
    color: #fff;
    background-color: ${(props) => props.theme.color.contrast};

    & span {
      color: #fff;
    }
  }

  input:checked ~ label .collapser {
    background-color: ${(props) => props.theme.color.contrast};
    background-image: url(${closeIcon});
    background-repeat: no-repeat;
    background-position: center;
  }

  & label .collapser {
    ${(props) =>
      props.main ? `border-left: 1px solid ${props.theme.color.contrast}` : ''};
  }
`

const Label = styled.label`
  cursor: pointer;
  user-select: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  //border: 2px solid transparent;

  .left {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 20px;
    flex: 1;
    border: 2px solid transparent;
  }

  background: #fff;

  .collapser {
    max-width: 54px;
    border-left: 1px solid ${(props) => props.theme.color.greyAlt};
    background-color: rgba(213, 0, 50, 0.2);
    background-image: url(${plusIcon});
    background-repeat: no-repeat;
    background-position: center;
    z-index: 2;
    cursor: pointer;
    -webkit-transition: 50ms;
    transition: 50ms;
    background-size: 15px;
    flex-basis: 0;
    flex-grow: 1;
    text-indent: -9999999999999px;
  }
`

const Collapse = styled(motion.div)`
  cursor: pointer;
  user-select: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background: #fff;
  margin-bottom: 2px;
  // border: 2px solid ${(props) => props.theme.color.contrast};

  .left {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 20px;
    flex: 1;
    border: 1px solid ${(props) => props.theme.color.contrast};
    border-right: none;
  }

  .collapser {
    max-width: 54px;
    border: 1px solid ${(props) => props.theme.color.contrast};
    background-color: #fff;
    background-image: url(${chevronDownIcon});
    background-repeat: no-repeat;
    background-position: center;
    z-index: 2;
    cursor: pointer;
    -webkit-transition: 50ms;
    transition: 50ms;
    background-size: 15px;
    flex-basis: 0;
    flex-grow: 1;
    text-indent: -9999999999999px;
  }
`

const GridFilter = ({
  main,
  taxonomy,
  // max,
  title,
  tag,
  activeFilterType,
  onChange,
  // onClear,
  isGridsOpen,
  setIsGridsOpen,
  setPage,
}) => {
  const isOpen = isGridsOpen[tag] || main

  /**
   * to prevent duplicates
   */
  function handleChange(item) {
    setPage(1)

    if (activeFilterType.includes(item)) {
      onChange(activeFilterType.filter((i) => i !== item))
    } else {
      onChange([...activeFilterType, item])
    }
  }

  if (taxonomy.length === 0) {
    return false
  }

  function handleOpening() {
    const newIsGrifsOpen = { ...isGridsOpen }
    const newIsOpen = !isGridsOpen[tag]

    newIsGrifsOpen[tag] = newIsOpen

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(
        'project-filters-open',
        JSON.stringify(newIsGrifsOpen)
      )
    }

    setIsGridsOpen(newIsGrifsOpen)
  }

  return (
    <div className="filter-wrapper mb-4 col-12 px-0">
      {!main && (
        <Collapse initial={false} onClick={() => handleOpening()}>
          <div className="left">{title}</div>
          <span role="button" className="collapser">
            Collapse
          </span>
        </Collapse>
      )}

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0, marginBottom: '5px' },
            }}
            transition={{ duration: 0.3 }}
          >
            {taxonomy
              .filter(({ name }) => name !== 'Uncategorized')
              .map(({ name: item, count }) => {
                return (
                  <Taxonomy
                    key={item}
                    main={main}
                    className={`filter-field d-flex align-items-center${
                      main ? ' mb-4' : ''
                    }`}
                  >
                    <input
                      type="checkbox"
                      className="mr-3"
                      value={activeFilterType.includes(item)}
                      checked={activeFilterType.includes(item)}
                      id={`${tag}_${item}`}
                      onChange={() => handleChange(item)}
                    />
                    <Label
                      className="color-text-main mb-0"
                      htmlFor={`${tag}_${item}`}
                    >
                      <div className="left">
                        {parse(item)}{' '}
                        <span className="color-text-contrast ml-2">
                          ({count})
                        </span>
                      </div>
                      <span role="button" className="collapser">
                        Collapse
                      </span>
                    </Label>
                  </Taxonomy>
                )
              })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default GridFilter
